<!-- 付款单信息 -->
<template>
  <base-form
    v-model="formData"
    :options="formData.transferType != 'TT03' ? options : TT03Options"
    ref="formData"
    :disabled="!canEdit"
    @input="handleChange"
    label-width="100px"
  >
  </base-form>
</template>

<script>
  import BaseForm from '@/components/form/base-form';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  import API from '@/api/financeCenter/transfer';
  import DataBaseAPI from '@/api/dataBase';
  import { mapState } from 'vuex';
  // import searchTable from '@/components/form-item/search-table';
  import XEUtils from 'xe-utils';
  export default {
    name: 'baseInfo',
    components: {
      BaseForm,
      // ajaxSelect,
      // searchTable,
    },
    props: ['companyList', 'detail', 'query', 'canEdit', 'transferType'],
    data() {
      // const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      return {
        departmentList: [], // 部门列表
        isInsureTypeList: [
          { id: '0', name: '否' },
          { id: '1', name: '是' },
        ],
        editConfig: {},
        tableToolbar: {},
        fileTableLoad: false,
        formData: {
          createByName: null,
          createBy: null,
          id: null,
          transferType: null, // '转款单类型TT01-付款转款,TT02-收款转款,TT03-抹账'
          transferNo: null, // 转款单号
          transferDate: null, // 转款日期
          businessCompanyCode: null, // 业务公司编码
          businessCompanyName: null, // 业务公司名称
          originBusinessDepartmentCode: null, //原业务部门代码
          originBusinessDepartmentName: null, //原业务部门名称
          transferBusinessDepartmentCode: null, //转款业务部门代码
          transferBusinessDepartmentName: null, //转款业务部门名称
          originPartnerCode: null, //原合作伙伴编码
          originPartnerName: null, // 原合作伙伴名称
          originPartnerType: null, // 原合作伙伴类别(字典),过滤下,只显示供应商客户两种类型
          transferPartnerCode: null, // 转款合作伙伴编码
          transferPartnerName: null, // 转款合作伙伴名称
          transferPartnerType: null, // 转款合作伙伴类别(字典),过滤下,只显示供应商客户两种类型
          originAmount: null, //原交易金额,付款金额或者收款金额
          transferAmount: null, //转款金额
          originAmountType: null, //原款项性质
          transferAmountType: null, //转款款项性质
          originContractNo: null, //原合同号
          transferContractNo: null, //新合同号
          currencyCode: null, //币种编码
          currencyName: null, //币种名称
          companyCurrencyCode: null, //本币币种编码
          companyCurrencyName: null, //本币币种名称
          exchangeType: '', //汇率类型(字典)
          exchangeRate: null, //汇率
          exchangeRateDate: null, //汇率日期
          companyOriginAmount: null, //原交易金额本币,付款金额或者收款金额
          companyTransferAmount: null, //转款金额本币
          transferStatus: null, //单据状态，saved-保存,submitted-提交,confirmed-已确认,withdrawn-已撤回,reversed-已冲销
          remark: null, //备注
          accountedDate: null, //入账日期
          accountingStatus: null, //入账状态
          amountUsage: 'other', //款项内容
          transferAmountUsage: 'other', //款项内容
        }, // 顶部表单的数据
        currency: '',
      };
    },
    watch: {
      'formData.exchangeRate': {
        handler(newValue, oldValue) {
          if (newValue !== oldValue) this.calCompanyAmout();
        },
        deep: true,
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        currencyList() {
          return this.$baseRequest.getDictListByType('all_currency');
        },
      }),
      orginExtraData() {
        let data = {
          adminFlag: this.userInfo.adminFlag,
          partnerTypes: '',
          departmentCode: this.formData.originBusinessDepartmentCode, //部门
          companyCode: this.formData.businessCompanyCode, //公司
        };
        if (this.formData.originPartnerType == 'HZHB02') {
          data.partnerTypes = 'HZHB03,HZHB02';
        } else if (this.formData.originPartnerType == 'HZHB01') {
          data.partnerTypes = 'HZHB03,HZHB01';
        }
        return data;
      },
      transferExtraData() {
        let data = {
          partnerTypes: 'HZHB03,HZHB02',
          departmentCode: this.formData.transferBusinessDepartmentCode, //部门
          companyCode: this.formData.businessCompanyCode, //公司
        };
        if (this.formData.transferPartnerType == 'HZHB02') {
          data.partnerTypes = 'HZHB03,HZHB02';
        } else if (this.formData.transferPartnerType == 'HZHB01') {
          data.partnerTypes = 'HZHB03,HZHB01';
        }
        return data;
      },
      //顶部表单配置--收款 付款用
      options() {
        // const data = this.formData;
        var validateOriginContract = (rule, value, callback) => {
          if (
            this.formData.transferType == 'TT01' &&
            !value &&
            this.formData.amountUsage == 'other'
          ) {
            callback(new Error('原合同号不能为空'));
          } else {
            callback();
          }
        };
        var validateOriginUsage = (rule, value, callback) => {
          if (
            this.formData.transferType == 'TT01' &&
            this.formData.originContractNo &&
            value != 'other'
          ) {
            callback(new Error('原款项类型需为货款'));
          } else {
            callback();
          }
        };
        var validateTransferContract = (rule, value, callback) => {
          if (
            this.formData.transferType == 'TT01' &&
            !value &&
            this.formData.transferAmountUsage == 'other'
          ) {
            callback(new Error('新合同号不能为空'));
          } else {
            callback();
          }
        };
        var validateTransferUsage = (rule, value, callback) => {
          if (
            this.formData.transferType == 'TT01' &&
            this.formData.transferContractNo &&
            value != 'other'
          ) {
            callback(new Error('新款项类型需为货款'));
          } else {
            callback();
          }
        };
        let arr = [
          {
            //单据号
            prop: 'transferNo',
            type: 'input',
            label: '转款单号',
            placeholder: '自动生成',
            disabled: true,
            clearable: true,
            required: false,
          },
          {
            //申请单公司代码
            prop: 'businessCompanyCode',
            type: 'select',
            options: this.companyList,
            label: '公司名称',
            clearable: true,
            required: true,
          },
          {
            //转账日期
            prop: 'transferDate',
            type: 'date',
            label: '转款日期',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //单据状态
            prop: 'transferStatus',
            type: 'dict',
            label: this.$t('withholdingList.withholdInfoAdd.column.docStatus'),
            dictType: 'transferStatus',
            placeholder: this.$t('withholdingList.placeholder.docNoPlaceholder'),
            disabled: true,
          },
          {
            //原付款部门
            prop: 'originBusinessDepartmentCode',
            span: 5,
            type: 'select',
            options: this.departmentList,
            label: this.getAtrrByType('originBusinessDepartmentCode'), //"原付款部门"  //
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //原供应商名称
            prop: 'originPartnerCode',
            span: 5,
            type: 'searchTable',
            searchType: 'partner',
            extraData: this.orginExtraData,
            currentValue: this.formData.originPartnerName,
            isMultiple: true,
            label: this.getAtrrByType('originPartnerCode'),
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //原付款金额
            prop: 'originAmount',
            label: this.getAtrrByType('originAmount'),
            span: 5,
            type: 'amountNumber',
            required: this.formData.transferType != 'TT01', //【ID1002245】转款单-0531
            disabled: this.formData.transferType == 'TT01',
          },
          {
            //原合同号
            prop: 'originContractNo',
            span: 5,
            label: '原合同号',
            type: 'searchTable',
            searchType: 'contract',
            name: 'originContractNo',
            getName: 'contractNo',
            code: 'originContractNo',
            getCode: 'contractNo',
            isMultiple: true,
            extraData:
              this.formData.transferType == 'TT01'
                ? {
                    contractCategory: 'purchase',
                    supplierNo: this.formData.originPartnerCode,
                  }
                : {
                    contractCategory: 'sales',
                    customerNo: this.formData.originPartnerCode,
                  },
            required: this.formData.transferType == 'TT01' && this.formData.amountUsage == 'other',
            validator: validateOriginContract,
          },
          {
            //款项内容
            prop: 'amountUsage',
            span: 4,
            type: 'dict',
            dictType: this.formData.transferType == 'TT01' ? 'amount_usage' : 'amount_usage_recive',
            label: '原款项内容',
            placeholder: '请选择原款项内容',
            clearable: true,
            validator: validateOriginUsage,
          },
          {
            //转款部门
            prop: 'transferBusinessDepartmentCode',
            span: this.formData.transferType == 'TT01' ? 5 : 4,
            type: 'select',
            options: this.departmentList,
            label: '转款部门',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //交易方类型
            prop: 'transferPartnerType',
            span: window.screen.width > 1366 ? 3 : 4,
            type: 'select',
            required: true,
            label: '交易方类型',
            placeholder: '请选择交易方类型',
            options: [{ value: 'HZHB01', label: '客户' }],
            disabled: true,
          },
          {
            //新供应商名称
            prop: 'transferPartnerCode',
            span: this.formData.transferType == 'TT01' ? 5 : window.screen.width > 1366 ? 3 : 2,
            type: 'searchTable',
            searchType: 'partner',
            extraData: this.transferExtraData,
            currentValue: this.formData.transferPartnerName,
            isMultiple: true,
            label:
              this.formData.transferType == 'TT01'
                ? this.getAtrrByType('transferPartnerCode')
                : null,
            labelWidth: this.formData.transferType == 'TT01' ? '100px' : '0px',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //转款金额
            prop: 'transferAmount',
            label: '转款金额',
            span: 5,
            type: 'amountNumber',
            required: true,
          },
          {
            //新合同号
            prop: 'transferContractNo',
            label: '新合同号',
            type: 'searchTable',
            searchType: 'contract',
            name: 'transferContractNo',
            getName: 'contractNo',
            code: 'transferContractNo',
            getCode: 'contractNo',
            isMultiple: true,
            extraData:
              this.formData.transferType == 'TT01'
                ? {
                    contractCategory: 'purchase',
                    supplierNo: this.formData.transferPartnerCode,
                  }
                : {
                    contractCategory: 'sales',
                    customerNo: this.formData.transferPartnerCode,
                  },
            span: 5,
            required:
              this.formData.transferType == 'TT02' ||
              (this.formData.transferType == 'TT01' &&
                this.formData.transferAmountUsage == 'other'),
            validator: validateTransferContract,
          },
          {
            //款项内容
            prop: 'transferAmountUsage',
            span: 4,
            type: 'dict',
            dictType: this.formData.transferType == 'TT01' ? 'amount_usage' : 'amount_usage_recive',
            label: '新款项内容',
            placeholder: '请选择新款项内容',
            clearable: true,
            validator: validateTransferUsage,
          },
          {
            //币种
            prop: 'currencyCode',
            type: 'dict',
            label: this.$t('withholdingList.withholdInfoAdd.column.currencyCode'),
            clearable: true,
            dictType: 'all_currency',
            required: true,
          },
          {
            //汇率类型、汇率
            prop: 'exchangeType',
            type: 'dict',
            label: this.$t('withholdingList.withholdInfoAdd.column.exchangeRate'),
            clearable: true,
            dictType: 'exchange_type',
            required: true,
            moreInput: true,
            ruleType: 'object',
            validatorKey: this.formData.exchangeRate,
            moreProp: 'exchangeRate',
            morePlaceholder: this.$t('withholdingList.placeholder.exchangeRatePlaceholder'),
            moreClearable: true,
            moreRequired: true,
            moreDisabled:
              this.formData.currencyCode == this.formData.companyCurrencyCode ||
              this.formData.exchangeType == 'Cooperate',
          },
          {
            //本币转款金额
            prop: 'companyTransferAmount',
            type: 'amountNumber',
            label: '本币转款金额',
            placeholder: '自动生成',
            clearable: true,
            disabled: true,
            required: false,
          },
          {
            //汇率日期
            prop: 'exchangeRateDate',
            type: 'date',
            label: '汇率日期',
            placeholder: '请选择汇率日期',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //创建日期
            prop: 'gmtCreate',
            type: 'date',
            label: '创建日期',
            placeholder: '自动生成',
            clearable: true,
            disabled: true,
            required: false,
          },
          {
            //入账状态
            prop: 'accountingStatus',
            label: this.$t('withholdingList.withholdInfoAdd.column.accountingStatus'),
            type: 'dict',
            dictType: 'post_status',
            clearable: true,
            disabled: true,
          },
          {
            //创建人
            prop: 'createByName',
            label: '创建人',
            type: 'input',
            clearable: true,
            disabled: true,
          },
          {
            //备注
            prop: 'remark',
            label: '备注',
            type: 'textarea',
            clearable: true,
            disabled: false,
            span: 24,
          },
        ];
        if (this.formData.transferType == 'TT01')
          XEUtils.remove(arr, (item) => item.prop == 'transferPartnerType');
        return arr;
      },

      //抹账表单配置
      TT03Options() {
        // const data = this.formData;
        return [
          {
            //单据号
            prop: 'transferNo',
            type: 'input',
            label: '转款单号',
            placeholder: '自动生成',
            disabled: true,
            clearable: true,
            required: false,
          },
          {
            //申请单公司代码
            prop: 'businessCompanyCode',
            type: 'select',
            options: this.companyList,
            label: '公司名称',
            placeholder: '请选择公司',
            clearable: true,
            required: true,
          },
          {
            //原收款部门
            prop: 'originBusinessDepartmentCode',
            type: 'select',
            options: this.departmentList,
            label: '抹账方部门', //"原收款部门"  //
            placeholder: '请选择收款部门',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //原付款部门
            prop: 'transferBusinessDepartmentCode',
            type: 'select',
            options: this.departmentList,
            label: '被抹账方部门',
            placeholder: '请选择付款部门',
            clearable: true,
            disabled: false,
            required: true,
          },
          // 抹账方
          { type: 'subTitle', label: '抹账方' },
          {
            //原合作伙伴类型
            span: 5,
            prop: 'originPartnerType',
            type: 'select',
            label: '抹账方类型',
            required: true,
            placeholder: '请选择抹账方类型',
            options: [
              { value: 'HZHB01', label: '客户' },
              { value: 'HZHB02', label: '供应商' },
            ],
            disabled: true,
          },
          {
            //抹账方名称
            span: 5,
            prop: 'originPartnerCode',
            type: 'searchTable',
            searchType: 'partner',
            extraData: this.orginExtraData,
            currentValue: this.formData.originPartnerName,
            isMultiple: true,
            label: '抹账方名称',
            placeholder: '请选择抹账方名称',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //原款项性质 金额
            span: 5,
            prop: 'originAmountType',
            type: 'select',
            label: '款项性质',
            placeholder: '请选原择款项性质',
            clearable: true,
            options: this.getAmoutTypeOptions('originAmountType'),
            required: true,
            moreInput: true,
            moreType: 'number',
            ruleType: 'object',
            validatorKey: this.formData.originAmount,
            moreProp: 'originAmount',
            morePlaceholder:
              '请' +
              this.$baseRequest.getDictValueByType('amountType', this.formData.originAmountType) +
              '输入金额',
            moreClearable: true,
            moreRequired: true,
            moreDisabled: false,
          },
          {
            //原合同号
            prop: 'originContractNo',
            span: 5,
            label:
              '原' +
              this.$baseRequest.getDictValueByType('amountType', this.formData.originAmountType) +
              '合同号',
            type: 'searchTable',
            searchType: 'contract',
            name: 'originContractNo',
            getName: 'contractNo',
            code: 'originContractNo',
            getCode: 'contractNo',
            isMultiple: true,
            extraData: {
              contractCategory: 'purchase',
              supplierNo: this.formData.originPartnerCode,
            },
            required:
              this.formData.originAmountType == 'yingfu' && this.formData.amountUsage == 'other',
          },
          {
            //款项内容
            prop: 'amountUsage',
            span: 4,
            type: 'dict',
            dictType: 'amount_usage',
            label: '原款项内容',
            placeholder: '请选择原款项内容',
            clearable: true,
          },
          //被抹账方
          { type: 'subTitle', label: '被抹账方' },
          {
            //被抹账合作伙伴类型
            span: 5,
            prop: 'transferPartnerType',
            type: 'select',
            required: true,
            label: '被抹账方类型',
            placeholder: '请选择被抹账方类型',
            options: [
              { value: 'HZHB01', label: '客户' },
              { value: 'HZHB02', label: '供应商' },
            ],
            disabled: true,
          },
          {
            //被抹账方名称
            span: 5,
            prop: 'transferPartnerCode',
            type: 'searchTable',
            searchType: 'partner',
            extraData: this.transferExtraData,
            currentValue: this.formData.transferPartnerName,
            isMultiple: true,
            label: '被抹账方名称',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //现款项性质 金额
            span: 5,
            prop: 'transferAmountType',
            type: 'dict',
            label: '款项性质',
            clearable: true,
            dictType: 'amountType',
            required: true,
            disabled: true,
            moreInput: true,
            moreType: 'number',
            ruleType: 'object',
            validatorKey: this.formData.transferAmount,
            moreProp: 'transferAmount',
            morePlaceholder:
              '请' +
              this.$baseRequest.getDictValueByType('amountType', this.formData.transferAmountType) +
              '输入金额',
            moreClearable: true,
            moreRequired: true,
            moreDisabled: false,
          },
          {
            //新合同号
            prop: 'transferContractNo',
            span: 5,
            label:
              '新' +
              this.$baseRequest.getDictValueByType('amountType', this.formData.transferAmountType) +
              '合同号',
            type: 'searchTable',
            searchType: 'contract',
            isMultiple: true,
            name: 'transferContractNo',
            getName: 'contractNo',
            code: 'transferContractNo',
            getCode: 'contractNo',
            extraData: {
              contractCategory: 'sales',
              customerNo: this.formData.transferPartnerCode,
            },
          },
          {
            //款项内容
            prop: 'transferAmountUsage',
            span: 4,
            type: 'dict',
            dictType: 'amount_usage_recive',
            label: '新款项内容',
            placeholder: '请选择新款项内容',
            clearable: true,
          },

          {
            //币种
            prop: 'currencyCode',
            type: 'dict',
            label: this.$t('withholdingList.withholdInfoAdd.column.currencyCode'),
            clearable: true,
            dictType: 'all_currency',
            required: true,
          },
          {
            //汇率类型、汇率
            prop: 'exchangeType',
            type: 'dict',
            label: this.$t('withholdingList.withholdInfoAdd.column.exchangeRate'),
            clearable: true,
            dictType: 'exchange_type',
            required: true,
            moreInput: true,
            ruleType: 'object',
            validatorKey: this.formData.exchangeRate,
            moreProp: 'exchangeRate',
            morePlaceholder: this.$t('withholdingList.placeholder.exchangeRatePlaceholder'),
            moreClearable: true,
            moreRequired: true,
            moreDisabled:
              this.formData.currencyCode == this.formData.companyCurrencyCode ||
              this.formData.exchangeType == 'Cooperate',
          },
          {
            //抹账金额
            prop: 'transferAmount',
            label: '抹账金额',
            type: 'amountNumber',
            required: true,
          },
          {
            //汇率日期
            prop: 'exchangeRateDate',
            type: 'date',
            label: '汇率日期',
            placeholder: '请选择汇率日期',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //抹账日期
            prop: 'transferDate',
            type: 'date',
            label: '抹账日期',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //单据状态
            prop: 'transferStatus',
            type: 'dict',
            label: this.$t('withholdingList.withholdInfoAdd.column.docStatus'),
            dictType: 'transferStatus',
            placeholder: this.$t('withholdingList.placeholder.docNoPlaceholder'),
            disabled: true,
          },

          {
            //本币转款金额
            prop: 'companyTransferAmount',
            type: 'amountNumber',
            label: '本币抹账金额',
            placeholder: '自动生成',
            clearable: true,
            disabled: true,
            required: false,
          },
          {
            //创建日期
            prop: 'gmtCreate',
            type: 'date',
            label: '创建日期',
            placeholder: '自动生成',
            clearable: true,
            disabled: true,
            required: false,
          },
          {
            //入账状态
            prop: 'accountingStatus',
            label: this.$t('withholdingList.withholdInfoAdd.column.accountingStatus'),
            type: 'dict',
            dictType: 'post_status',
            clearable: true,
            disabled: true,
          },
          {
            //创建人
            prop: 'createByName',
            label: '创建人',
            type: 'input',
            clearable: true,
            disabled: true,
          },
          {
            //备注
            prop: 'remark',
            label: '备注',
            type: 'textarea',
            clearable: true,
            disabled: false,
            span: 24,
          },
        ];
      },
    },
    mounted() {
      this.formData.createBy = this.userInfo.userCode;
      this.formData.createName = this.userInfo.userName;
    },
    methods: {
      getAtrrByType(flag) {
        if (this.formData.transferType == 'TT01') {
          if (flag == 'originBusinessDepartmentCode') {
            return '原付款部门';
          } else if (flag == 'originPartnerCode') {
            return '原供应商名称';
          } else if (flag == 'originAmount') {
            return '原付款金额';
          } else if (flag == 'transferPartnerCode') {
            return '新供应商名称';
          }
        } else if (this.formData.transferType == 'TT02') {
          if (flag == 'originBusinessDepartmentCode') {
            return '原收款部门';
          } else if (flag == 'originPartnerCode') {
            return '原客户名称';
          } else if (flag == 'originAmount') {
            return '原收款金额';
          } else if (flag == 'transferPartnerCode') {
            return '交易方名称';
          }
        } else if (this.formData.transferType == 'TT03') {
          if (flag == 'originBusinessDepartmentCode') {
            return '原收款部门';
          } else if (flag == 'originPartnerCode') {
            return '交易方名称';
          } else if (flag == 'originAmount') {
            return '原收款金额';
          } else if (flag == 'transferPartnerCode') {
            return '交易方名称';
          }
        }
      },
      // 根据条件获取不同的款项性质列表
      getAmoutTypeOptions(prop) {
        let result = [];
        if (this.formData.transferType == 'TT03') {
          if (prop == 'originAmountType') {
            let list = this.$baseRequest.getDictListByType('amountType') || [];
            if (list[0]) {
              result = list.filter((item) => ['yingfu', 'yufu'].includes(item.value));
            }
          }
        }
        return result;
      },
      handleChange(v, prop) {
        this.formData[prop] = v[prop];
        if (prop == 'businessCompanyCode') {
          //公司编码
          this.formData.businessCompanyCode = v[prop];
          this.formData.originBusinessDepartmentCode = '';
          this.formData.originBusinessDepartmentName = '';
          if (!v[prop]) return;
          this.formData.businessCompanyName = this.companyList.find(
            (it) => it.value == v[prop]
          ).label;
          this.getdepartmentList(this.formData.businessCompanyCode);
          this.getLedger(this.formData.businessCompanyCode);
        } else if (prop.indexOf('DepartmentCode') !== -1) {
          //部门编码
          this.formData[prop] = v[prop];
          let departmentName = prop.replace('DepartmentCode', 'DepartmentName');
          this.formData[departmentName] = this.departmentList.find(
            (it) => it.value == v[prop]
          ).label;
        } else if (prop == 'currencyCode') {
          //币种
          this.formData.currencyName =
            this.currencyList.find((i) => i.currencyCode === v[prop]) &&
            (this.currencyList.find((i) => i.currencyCode === v[prop]).currencyName || '');
          this.selectTaxRate();
        } else if (prop == 'transferDate') {
          if (!this.formData.exchangeRateDate) {
            this.formData.exchangeRateDate = this.formData.transferDate;
            this.selectTaxRate();
          }
        } else if (prop == 'originPartnerType') {
          this.formData.originPartnerCode = null;
          this.formData.originPartnerName = null;
          this.formData.originContractNo = null;
        } else if (prop == 'transferPartnerType') {
          this.formData.transferPartnerCode = null;
          this.formData.transferPartnerName = null;
          this.formData.transferContractNo = null;
        } else if (prop == 'originPartnerCode') {
          //原合作伙伴
          let partner = v[prop];
          this.formData.originContractNo = null;
          if (partner && partner.length > 0) {
            this.formData.originPartnerCode = partner[0].partnerCode;
            this.formData.originPartnerName = partner[0].partnerZhName;
          } else {
            this.formData.originPartnerCode = null;
            this.formData.originPartnerName = null;
          }
        } else if (prop == 'transferPartnerCode') {
          //转款合作伙伴
          let partner = v[prop];
          this.formData.transferContractNo = null;
          if (partner && partner.length > 0) {
            this.formData.transferPartnerCode = partner[0].partnerCode;
            this.formData.transferPartnerName = partner[0].partnerZhName;
          } else {
            this.formData.transferPartnerCode = null;
            this.formData.transferPartnerName = null;
          }
        } else if (prop == 'originAmount') {
          if (this.formData.transferType == 'TT03') {
            this.formData.transferAmount = this.formData.originAmount;
          }
          this.calCompanyAmout();
        } else if (prop == 'transferAmount') {
          if (this.formData.transferType != 'TT02') {
            this.formData.originAmount = this.formData.transferAmount;
          }
          this.calCompanyAmout();
        } else if (prop == 'exchangeRateDate' || prop == 'exchangeType') {
          this.selectTaxRate();
        } else if (prop == 'originAmountType') {
          this.formData.transferAmountType =
            this.formData.originAmountType == 'yingfu' ? 'yushou' : 'yingshou';
        }
      },
      // 获取公司对应本币位
      getLedger(companyCode) {
        this.$baseRequest.getLedger(companyCode).then((res) => {
          if (res.length > 0) {
            //如果换公司，则币种都默认变化
            this.formData.companyCurrencyCode = res[0].currencyCode;
            this.formData.companyCurrencyName = res[0].currencyName;
            //默认汇率类型
            this.formData.exchangeType = res[0].defaultExchangeType;
            this.formData.currencyCode = res[0].currencyCode;
            this.formData.currencyName = res[0].currencyName;
            this.selectTaxRate();
          } else {
            //没有查询到公司账套
            this.formData.companyCurrencyCode = null;
            this.formData.exchangeType = null;
            this.formData.exchangeRate = null;
            this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
          }
        });
      },
      //获取汇率
      getRate() {
        if (this.formData.currencyCode || this.formData.companyCurrencyCode) {
          // const { tenantCode, companyCode, departmentCode } = this.userInfo;
          const params = {
            fromCurrencyCode: this.formData.currencyCode,
            toCurrencyCode: this.formData.companyCurrencyCode,
            exchangeType: this.formData.exchangeType,
            exchangeDate: this.formData.exchangeRateDate,
          };
          this.$baseRequest.getRate(params).then((res) => {
            if (res) {
              this.formData.exchangeRate = res.positiveRate;
            } else {
              this.formData.exchangeRate = null;
              this.$message({ showClose: true, message: '缺少对应汇率，请维护', type: 'error' });
            }
          });
        }
      },
      //获取采购合同相关信息
      getContractData(res) {
        //预提类型为出口运费和出口佣金，"供应商/客户"展示客户内容
        if (this.formData.accruedType == 'YT16' || this.formData.accruedType == 'YT17') {
          this.formData.supplierName = res[0].customerName;
          this.formData.supplierNo = res[0].customerNo;
        } else {
          this.formData.supplierName = res[0].supplierName;
          this.formData.supplierNo = res[0].supplierNo;
        }
        this.formData.currencyCode = res[0].contractCurrency;
        this.formData.currencyName = res[0].contractCurrencyName;
        this.formData.tradeType = res[0].tradeType;
        this.selectTaxRate();
      },
      // 获取部门
      async getdepartmentList(companyCode) {
        // TODO 公司代码字段未定
        this.departmentList = [];
        const selectStatus = await this.$axios.post(
          DataBaseAPI.LIST_DEPARTMENT_API + '/' + companyCode,
          {}
        );
        if (selectStatus.data.code == 0) {
          this.departmentList = selectStatus.data.data || [];
        }
      },
      //币种选择
      selectCurrency(v) {
        this.formData.currencyName = this.currencyList.find(
          (i) => i.currencyCode === v
        ).currencyName;
        this.selectTaxRate();
      },
      // 汇率值获取
      selectTaxRate() {
        // let taxRate;
        if (
          this.formData.companyCurrencyCode &&
          this.formData.currencyCode &&
          this.formData.companyCurrencyCode === this.formData.currencyCode
        ) {
          this.formData.exchangeRate = 1;
        } else if (this.formData.companyCurrencyCode && this.formData.currencyCode) {
          this.getRate();
        }
      },
      // 获取汇率
      selectExchangeType(fromCurrencyCode) {
        return this.$axios.post(API.GET_CURRENCY_EXCHANGE, { fromCurrencyCode }).then((res) => {
          if (res.data.code !== 0) {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 计算本币金额
      calCompanyAmout() {
        this.formData.companyOriginAmount = this.$cal.calCommon(
          this.formData.originAmount,
          this.formData.exchangeRate,
          '*',
          'amount'
        );
        this.formData.companyTransferAmount = this.$cal.calCommon(
          this.formData.transferAmount,
          this.formData.exchangeRate,
          '*',
          'amount'
        );
      },
    },
  };
</script>
